import React from 'react';

import Button from '@material-ui/core/Button';

import clsx from 'clsx';

import useBreakpoint from 'hooks/useBreakpoint/useBreakpoint';
import getProviderDisplayNames from 'utils/providerUtils';

import * as mainStyles from '../styles';
import { useStyles } from './styles';
import { ProviderPillParams } from './types';

const ProviderPill = ({ provider, setProviderConfirmed, setSelectedProvider }: ProviderPillParams) => {
  const classes = useStyles();
  const mainClasses = mainStyles.useStyles();
  const lines = getProviderDisplayNames(provider);
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === 'xs';

  //TODO this can be refactored to use context instead of passed down functions

  const confirmProvider = () => {
    setProviderConfirmed(true);
  };

  const removeProvider = () => {
    setSelectedProvider(null);
  };

  return (
    <>
      <div className={classes.pillContainer}>
        {provider.real_photo_path ? (
          <img
            className={clsx({
              [mainClasses.providerPreviewImgPill]: !isMobile,
              [mainClasses.providerPreviewImgPillMobile]: isMobile,
            })}
            src={provider.real_photo_path}
            alt="provider"
          />
        ) : (
          <div
            className={clsx({
              [mainClasses.providerPreviewImgPill]: !isMobile,
              [mainClasses.providerPreviewImgPillMobile]: isMobile,
            })}
          >
            <svg>
              <use
                xlinkHref={provider.gender && provider.gender === 'F' ? '#icon-provider-female' : '#icon-provider-male'}
              />
            </svg>
          </div>
        )}
        <div className={classes.providerInfoContainer}>
          <div className={mainClasses.providerPillName} title={lines[0]}>
            {lines[0]}
          </div>
          <div className={mainClasses.providerPillAddress} title={lines[1]}>
            {lines[1]}
          </div>
          <div className={mainClasses.providerPillAddress} title={lines[2]}>
            {lines[2]}
          </div>
        </div>
        <div className={`${classes.buttonContainer} ${mainClasses.alignRightContainer}`}>
          <Button classes={{ root: clsx(mainClasses.button, mainClasses.noBoxShadow) }} variant="contained" color="primary" onClick={confirmProvider}>
            That's me!
          </Button>
        </div>
      </div>
      <div
        className={clsx({
          [mainClasses.alignRightContainer]: !isMobile,
          [mainClasses.alignCenterContainer]: isMobile,
        })}
      >
        <Button
          classes={{ root: mainClasses.secondaryButton }}
          variant="outlined"
          color="primary"
          onClick={removeProvider}
        >
          This isn't me
        </Button>
      </div>
    </>
  );
};
export default ProviderPill;
